module.exports = __webpack_public_path__ + "static/media/pdf.eba121e7.png";